<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: 'primary' | 'secondary' | 'ghost' | 'accent';
    size?: 'default' | 'sm' | 'icon';
    type?: 'button' | 'submit';
    disabled?: boolean;
    loading?: boolean;
    /** Required when the button renders only an icon. */
    label?: string;
  }>(),
  {
    variant: 'secondary',
    size: 'default',
    type: 'button',
    disabled: false,
    loading: false,
  },
);
</script>

<template>
  <button
    class="shio-btn"
    :class="[
      `shio-btn--${variant}`,
      size === 'sm' && 'shio-btn--sm',
      size === 'icon' && 'shio-btn--icon',
    ]"
    :type="type"
    :disabled="disabled || loading"
    :aria-label="label"
    :aria-busy="loading || undefined"
  >
    <span v-if="loading" class="shio-btn__spinner" aria-hidden="true" />
    <slot />
  </button>
</template>

<style scoped>
.shio-btn__spinner {
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: var(--shio-radius-pill);
  animation: shio-spin 0.7s linear infinite;
}

@keyframes shio-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
